// import http from './http'
// import store from '@/store'
// import _globa from './globa'// 引用文件
// let base = window.SITE_CONFIG['apiURL']

export const track = {
  // 知识社区首页-技术文档详情
  clickDocDetail: (item) => {
    // http.post(`${base}/buryingpoint/buryingpoint/technicalDocDetail`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  },
  // 知识社区首页-技术视频详情
  clickVideoDetail: (item) => {
    // http.post(`${base}/buryingpoint/buryingpoint/technicalvideoDetail`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  },
  // 知识社区资料列表页-分类点击
  clickDocCategory: (item) => {
    // http.post(`${base}/buryingpoint/buryingpoint/technicalDocClassification`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  },
  // 知识社区视频列表页-分类点击
  clickVideoCategory: (item) => {
    // http.post(`${base}/buryingpoint/buryingpoint/technicalvideoClassification`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  },
  // 技术文档详情-收藏
  clickDocCollection: (item) => {
    // http.post(`${base}/buryingpoint/buryingpoint/technicalDocDetailCollection`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  },
  // 技术视频详情-收藏
  clickVideoCollection: (item) => {
    // http.post(`${base}/buryingpoint/buryingpoint/technicalvideoDetaiCollection`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  },
  // 技术文档详情-下载
  clickDocDownload: (item) => {
    // http.post(`${base}/buryingpoint/buryingpoint/technicalDocDetailDownload`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  },
  // 知识社区首页-上传资料
  clickUploadFile: (item) => {
    // http.post(`${base}//buryingpoint/buryingpoint/uploadData`, {
    //   keyWord: item,
    //   userId: store.state.user.id
    // })
  }
}
